import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { CreateDocumentDto } from 'src/app/modules/documents/models/documents.model';
import {
  selectDocumentCreating,
  selectSendingReport,
  selectUploadingDocumentData,
  selectUploadingDocumentVersionData,
} from 'src/app/modules/documents/store/selectors';
import { UploadingDocumentVersionData } from 'src/app/modules/documents/store/state';
import { AppState } from '../../../store/state';

@UntilDestroy()
@Component({
  selector: 'app-document-loader-notification',
  templateUrl: './document-loader-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DocumentLoaderNotificationComponent implements OnInit {
  public creatingDocument: boolean = false;
  public sendingReport: boolean = false;
  public document: CreateDocumentDto | null = null;
  public documentVersion: UploadingDocumentVersionData | null = null;

  constructor(
    private store$: Store<AppState>,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.store$.select(selectDocumentCreating),
      this.store$.select(selectUploadingDocumentData),
      this.store$.select(selectUploadingDocumentVersionData),
      this.store$.select(selectSendingReport),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([creatingDocument, document, documentVersion, sendingReport]) => {
        this.creatingDocument = creatingDocument;
        this.sendingReport = sendingReport;
        this.document = document;
        this.documentVersion = documentVersion;

        this.cdr.markForCheck();
      });
  }

  get docName(): string | undefined {
    return this.document?.properties.name;
  }

  get versionUploadName(): string {
    return this.documentVersion?.documentName || this.documentVersion?.fileName || '';
  }

  get versionUploadLabel(): string {
    return this.documentVersion?.versionLabel || '';
  }
}
